import React from "react"
import BrandingFeatureComponent
  from "../../../../../components/FeaturesComponents/modules/settings/branding/BrandingFeatureComponent"
import SsoFeatureComponent from "../../../../../components/FeaturesComponents/modules/settings/sso/SsoFeatureComponent"
import IntegrationsS3FeatureComponent
  from "../../../../../components/FeaturesComponents/modules/settings/integrations/s3/IntegrationsS3FeatureComponent"
import IntegrationsGoogleDriveFeatureComponent
  from "../../../../../components/FeaturesComponents/modules/settings/integrations/google-drive/IntegrationsGoogleDriveFeatureComponent"

const featuresArr = {
  appBranding: {
    key: 'app_branding',
    title: `Branding`,
    component: <BrandingFeatureComponent />,
    properties: ['overview your charts and statistics']
  },
  appSso: {
    key: 'app_sso',
    title: `SSO`,
    component: <SsoFeatureComponent />,
    properties: ['overview your charts and statistics']
  },
  appIntegrationsS3: {
    key: 'app_integrations_s3',
    title: `Integrations S3`,
    component: <IntegrationsS3FeatureComponent />,
    properties: ['overview your charts and statistics']
  },
  appIntegrationsGoogleDrive: {
    key: 'app_integrations_google_drive',
    title: `Integrations Google Drive`,
    component: <IntegrationsGoogleDriveFeatureComponent />,
    properties: ['overview your charts and statistics']
  }
}

export default featuresArr